import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ga4Event } from '../../../../../../shared/utils/ga4Event';
import { SPONSORSHIP_MAX_BONUS } from '../../../../../../../shared/helpers/sponsorshipHelper';
import SponsorshipBonusesTable from '../../../../../components/Marketing/components/SponsorshipBonusesTable';

import { Button } from 'hosman-material';

const SponsorshipCard = () => {
  const { user } = useSelector(state => state.user);

  return (
    <Link to='parrainage' onClick={() => ga4Event('click_parrainage_home', { user_id: user.id })}>
      <div className='flex flex-col gap-8 text-ih-indigo border-2 border-ih-purple-20 hover:border-ih-purple-40 bg-hosman-gradient-1 rounded-3xl px-4 py-10 md:px-7 md:py-14' data-testid='SponsorshipCard'>
        <div className='text-xl font-bold text-ih-indigo text-center'>
          <p>Envie de gagner jusqu'à {SPONSORSHIP_MAX_BONUS.toLocaleString('fr-FR')}€ ?</p>
          <p>Parrainez un proche !</p>
        </div>

        <div className='flex flex-wrap gap-3 justify-center'>
          <div className='flex flex-col items-center gap-3 border border-ih-blue-70 rounded-2xl bg-white p-3'>
            <p className='font-medium'>Acte authentique</p>

            <SponsorshipBonusesTable />
          </div>
        </div>

        <div className='md:w-max mx-auto'>
          <Button label="Découvrez l'offre de parrainage" />
        </div>
      </div>
    </Link>
  );
}

export default SponsorshipCard;
